import styled, { css } from 'styled-components';

const GenericButton = styled.button`
  display: ${props => props.$display || 'inline-block'};
  background: ${props => props.$background || '#fff'};
  color: ${props => props.$color || 'black'};
  border: ${props => props.$border || '0.5px solid #000'};
  padding: ${props => props.$padding || '1rem 2rem'};
  font-size: ${props => props.$fontSize || '1rem'};
  font-weight: ${props => props.$fontWeight || 600};
  text-decoration: none;
  transition: all 0.2s ease;
  letter-spacing: -0.025em;
  width: ${props => props.$width || '100%'};
  max-width: ${props => props.$maxWidth || '320px'};
  font-family: ${props => props.$fontFamily || 'inherit'};
  border-radius: ${props => props.$borderRadius || '0'};
  cursor: pointer;
  line-height: ${props => props.$lineHeight || '1.2'};

  &:hover {
    background: ${props => props.$hoverBackground || '#fff'};
    color: ${props => props.$hoverColor || props.$color || 'black'};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(5, 6, 5, 0.3);
  }
  &:disabled {
    background: #cbd5e0;
    color: #a0aec0;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
  ${props => props.$fullWidth && css`
    width: 100%;
    max-width: 100%;
  `}
  ${props => props.$custom && css`${props.$custom}`}
`;

export default GenericButton; 